import { Component, Input, } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { SlicePipe, JsonPipe, CommonModule } from '@angular/common';
import { CardModule, CheckboxModule, DropdownModule, RadioButtonModule, AlertModule, TooltipModule } from 'axis-components';
import { BaseRules, TextValues } from './washington.model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-washington',
    standalone: true,
      imports: [
        CommonModule,
        CardModule,
        CheckboxModule,
        DropdownModule,
        ReactiveFormsModule,
        RadioButtonModule,
        AlertModule,
        SlicePipe,
        JsonPipe,
        TruncateModule,
        TooltipModule
      ],
  templateUrl: './washington.component.html',
  styleUrl: './washington.component.scss'
})
export class WashingtonComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
 @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('washington', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('washington', null);
    }
  }
}
